export interface SendPaymentRequestError {
  status: number;
  errorCode: string | null;
  title: string | null;
  detail: string | null;
  extensions: Record<string, unknown>;
}

export function toSendPaymentRequestError(err: unknown): SendPaymentRequestError {
  const anyErr = err as { status?: number; error?: unknown; response?: unknown } | null;
  const status = typeof anyErr?.status === 'number' ? anyErr.status : 0;
  // Three shapes reach here. HttpErrorResponse carries the body on `error`; the SDK's
  // SwaggerException (thrown for any status the endpoint did not declare) carries it as raw text on
  // `response`; and for a DECLARED status the SDK's throwException() rethrows the parsed
  // ProblemDetails instance itself, so the fields sit directly on the error object with no wrapper.
  // That last shape is the one every coded payment failure arrives in -- 409, 422 and 503.
  const body = parseBody(anyErr?.error ?? anyErr?.response ?? anyErr);

  const errorCode = pickString(body, 'errorCode');
  const title = pickString(body, 'title');
  const detail = pickString(body, 'detail');
  const extensions = body && typeof body === 'object'
    ? Object.fromEntries(Object.entries(body as Record<string, unknown>).filter(([k]) =>
        k !== 'errorCode' && k !== 'title' && k !== 'detail' && k !== 'status' && k !== 'instance' && k !== 'type'))
    : {};

  return { status, errorCode, title, detail, extensions };
}

function parseBody(raw: unknown): unknown {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'string') {
    try { return JSON.parse(raw); } catch { return null; }
  }
  return null;
}

function pickString(body: unknown, key: string): string | null {
  if (body == null || typeof body !== 'object') return null;
  const value = (body as Record<string, unknown>)[key];
  return typeof value === 'string' ? value : null;
}
